export class OrgAffiliationConst {
  public static SHELL = "SHELL";
  public static Shell_EXPRESS = "SE";
  public static SHELL_MOTORWAY = "SHM";
}
